/* @ngInject */
function homeService (ConnectorWebService, AssetService, ArtsService, CONSTANTS, Utils) {
  var service = {
    getHomeCampaigns,
    getHomePosts,
    getTasks,
    countTasks,
    getHomeTemplates,
    getLayersId,
    getAssetsArt,
    requestSrc,
    getImgSrc
  }
  return service

  function getHomeCampaigns (iTop, iSkip) {
    const url = Utils.fnAddTopSkipQueriesToUrl(CONSTANTS.URL_USERS_ME_CAMPAIGNS, iTop, iSkip)
    return ConnectorWebService.get(url)
  }

  function getHomePosts (iTop, iSkip) {
    const url = Utils.fnAddTopSkipQueriesToUrl(CONSTANTS.URL_USERS_ME_POSTS, iTop, iSkip)
    return ConnectorWebService.get(url)
  }

  function getTasks (iTop, iSkip) {
    const url = Utils.fnAddTopSkipQueriesToUrl(CONSTANTS.URL_USERS_ME_TASKS_ROLE, iTop, iSkip)
    return ConnectorWebService.get(url)
  }

  function countTasks () {
    return ConnectorWebService.get(CONSTANTS.URL_USERS_ME_TASKS_ROLE_COUNT)
  }

  function getHomeTemplates (iTop, iSkip) {
    const url = Utils.fnAddTopSkipQueriesToUrl(CONSTANTS.URL_USERS_LATEST_TEMPLATES, iTop, iSkip)
    return ConnectorWebService.get(url)
  }

  function getLayersId (id) {
    return ArtsService.findLayersId(id)
  }

  function getAssetsArt (artId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSETS_ID, [artId])
    return ConnectorWebService.get(url)
  }

  function requestSrc (assetId, type) {
    return {
      original: Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [assetId]),
      default: AssetService.getAssetThumbnailByType(type),
      thumbnail: Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_THUMBNAIL_ID, [assetId])
    }
  }

  function getImgSrc (artId) {
    return Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_PREVIEW, [artId])
  }
}

export { homeService }
